<template>  
  <div class="mt-10 pt-10">
    <v-row>
      <v-col cols="2">
        <report-list :reportList="reportList" :selectedReport="selectedReport" :selectReport="selectReport" />
      </v-col>
      <v-col>
        <viewer :reportName="selectedReport"/>
      </v-col>
    </v-row>
  </div>
</template>   

<script lang="ts">
import Vue from "vue";
import ReportList from '@/components/Admin/Reports/ReportList.vue';
import Viewer from '@/components/Admin/Reports/ReportViewer.vue';
import adminReportsService from "@/services/admin/reportsService";

export default Vue.extend({
  name: "TitlingProcess",
  components: {   
    ReportList,
    Viewer
  },
  data: function () {
    return {            
      reportList: [],
      selectedReport: "" as String
    };
  },
  beforeCreate() {
    adminReportsService.getReports()
      .then(result => {
        if(result.length > 0){
          //this.$data.selectedReport = result[0];
          this.$data.reportList = result;
        }
      })
      .catch(this.$handleError);
  },
  methods: {
    selectReport(reportName: String) {
      this.selectedReport = reportName;
    }
  }
});
</script>
